import { cn } from "@/lib/utils";
import RichText from "@/components/common/richText/richText.component";

export interface NumberedStep {
  title: string;
  // `**bold**` supported.
  text: string;
}

interface NumberedStepsProps {
  steps: NumberedStep[];
}

// Numbered step cards in a row (the preview's `.pz-st`): three steps sit
// three-up on desktop, four or more four-up, so no column is left empty.
// The number sits on top with a short dashed rule, and the title + text run
// the full card width below it - a number column beside the text squeezed
// the copy into a narrow strip. Sizes are explicit so the global h3 style
// doesn't apply.
const NumberedSteps = ({ steps }: NumberedStepsProps) => (
  <ol
    className={cn(
      "grid gap-4 sm:grid-cols-2",
      steps.length === 3 ? "lg:grid-cols-3" : "lg:grid-cols-4",
    )}
  >
    {steps.map((step, index) => (
      <li
        key={step.title}
        className="flex flex-col gap-3 rounded-3xl border border-line bg-white p-6 shadow-card"
      >
        <div className="flex items-center gap-3" aria-hidden="true">
          <span className="grid size-10 shrink-0 place-items-center rounded-full bg-primary text-base font-extrabold text-white">
            {index + 1}
          </span>
          <span className="h-[3px] flex-1 bg-dash-primary opacity-40" />
        </div>
        <h3 className="mt-1 text-lg leading-snug font-bold text-ink">
          {step.title}
        </h3>
        <p className="text-[15px] leading-relaxed text-ink-muted">
          <RichText text={step.text} />
        </p>
      </li>
    ))}
  </ol>
);

export default NumberedSteps;
